import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import LandingPage from "./pages/LandingPage";
import OpportunityPage from "./pages/OpportunityPage";

// Layout component that conditionally shows header/footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isCapturePage = location.pathname === '/';
  
  return (
    <>
      {!isCapturePage && <Header />}
      <main className={isCapturePage ? '' : 'min-h-screen'}>
        {children}
      </main>
      {!isCapturePage && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/opportunity" element={<OpportunityPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
